import React, {useContext} from 'react';
import {Col, Card, Image, Row} from 'react-bootstrap';

import {
    FaBookOpen, FaCalendar,
    FaGlobe, FaInfoCircle, FaStarHalfAlt,
} from "react-icons/fa";
import {Context} from "../../index";

const BookItems = ({ thisBook, onClick }) => {
    const { book } = useContext(Context);
    const date = new Date(thisBook?.createdAt) ;
    const bookRatingInfo = book?.getBookRatingInfo(thisBook.id);
    const isMobile = window.innerWidth < 480;

// Массив с сокращениями месяцев
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Получаем месяц, день, год, часы и минуты
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // ✅ Получаем данные по рейтингу книги

    return (
        <>
            {!isMobile && (
                <Col md={4} className="d-flex justify-content-center p-0">
                    <Card
                        className="mt-2 mb-0 p-0"
                        style={{
                            borderRadius: '6px',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                            height: '160px',
                            width: 'calc(100% - 10px)',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            cursor: 'pointer',
                            border: '1px solid gray',
                        }}
                        onClick={onClick}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = '0px 6px 16px rgba(0, 0, 0, 0.2)';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = '0px 2px 4px rgba(0, 0, 0, 0.1)';
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        <Card.Body>
                            <Row className="mt-0 p-0">
                                <Col md={4} className="d-flex justify-content-center align-items-center">
                                    <Image
                                        src={
                                            thisBook?.status === 'DELETED'
                                                ? `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`
                                                : thisBook?.cover_file
                                                    ? `${process.env.REACT_APP_API_URL}covers/${thisBook?.cover_file}`
                                                    : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`
                                        }
                                        style={{
                                            objectFit: 'contain',
                                            borderRadius: '6px',
                                            maxHeight: "120px",
                                            maxWidth: "90px",
                                            backgroundColor: "white",
                                        }}
                                    />
                                </Col>
                                <Col md={8} className="flex-column justify-content-start small p-0">
                                    <p
                                        className="fw-bold mb-0 text-muted"
                                        style={{
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            WebkitLineClamp: 1, // Ограничение до 2 строк
                                        }}
                                    >
                                        {thisBook?.title}
                                    </p>

                                    <p
                                        className="fst-italic mb-1 text-muted small"
                                        style={{
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            WebkitLineClamp: 1, // Ограничение до 2 строк
                                        }}
                                    >
                                        {thisBook?.subtitle || 'No subtitle'}
                                    </p>

                                    <Row className="gap-0">
                                        <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                            lineHeight: "1.3",
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            WebkitLineClamp: 1,
                                        }}>
                                            <FaBookOpen className="me-2" />
                                            A/S: <strong>{thisBook?.author}</strong>,


                                        </p>

                                        <p className="me-2 mb-0 mt-0 small text-muted" style={{
                                            lineHeight: "1.3",
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            WebkitLineClamp: 1,
                                        }}>
                                            <FaCalendar className="me-2" />
                                            Added: <strong>{`${month}-${day}-${year}`}</strong>,
                                        </p>

                                        <p
                                            className="me-2 mb-0 mt-0 small text-muted"
                                            style={{
                                                lineHeight: "1.3",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            <FaGlobe className="me-2" />
                                            Lang: <strong>{thisBook?.language}</strong>,&nbsp;
                                            {thisBook?.book_type === 'product' ? (
                                                <>FBA Product</>
                                            ) : (
                                                <>
                                                    <strong>{thisBook?.total_words}</strong> Words,
                                                </>
                                            )}
                                        </p>
                                        <p className="me-2 mb-0 mt-0 small text-muted"   style={{
                                            lineHeight: "1.3",
                                            whiteSpace: "nowrap",
                                        }}>
                                            <FaInfoCircle className="me-2" />
                                            Status: <strong >{thisBook?.status}</strong>,&nbsp;
                                            Reviews: <strong>{bookRatingInfo?.totalReviews || 'No'}</strong>,

                                        </p>
                                        <p className="me-2 mb-0 mt-0 small text-muted"   style={{
                                            lineHeight: "1.3",
                                            whiteSpace: "nowrap",
                                        }}>
                                            <FaStarHalfAlt className="me-2" />
                                            Rating:&nbsp;&nbsp;
                                            {[...Array(5)].map((_, index) => (
                                                <i
                                                    key={index}
                                                    className={`bi ${
                                                        index < Math.floor(bookRatingInfo?.successRating)
                                                            ? "bi-star-fill"
                                                            : index === Math.floor(bookRatingInfo?.successRating) && bookRatingInfo?.successRating % 1 >= 0.3 && bookRatingInfo?.successRating % 1 <= 0.7
                                                                ? "bi-star-half"
                                                                : "bi-star"
                                                    }`}
                                                    style={{
                                                        color:
                                                            index < Math.floor(bookRatingInfo?.successRating) ||
                                                            (index === Math.floor(bookRatingInfo?.successRating) && bookRatingInfo?.successRating % 1 >= 0.3 && bookRatingInfo?.successRating % 1 <= 0.7)
                                                                ? "gold"
                                                                : "lightgray",
                                                        fontSize: "14px",
                                                        marginRight: "3px",
                                                    }}
                                                ></i>
                                            ))}&nbsp;&nbsp;
                                            <strong>({bookRatingInfo?.successRating || 'No'})</strong>

                                        </p>

                                    </Row>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            )}

            {isMobile && (
                <Col xs={12} className="d-flex justify-content-center">
                    <Card
                        className="mt-2 mb-2 p-2"
                        style={{
                            width: '100%',
                            maxWidth: '380px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            border: '1px solid gray',
                        }}
                        onClick={onClick}
                    >
                        <Row className="g-2 p-1 align-items-center">
                            <Col xs={4} className="d-flex justify-content-center align-items-center">
                                <Image
                                    src={thisBook?.cover_file
                                        ? `${process.env.REACT_APP_API_URL}covers/${thisBook?.cover_file}`
                                        : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`}
                                    style={{
                                        objectFit: 'contain',
                                        borderRadius: '4px',
                                        maxHeight: "130px",
                                        maxWidth: "90px",
                                        backgroundColor: "white",
                                    }}
                                />
                            </Col>

                            <Col xs={8} className="text-muted small">
                                <p className="fw-bold mb-0 text-truncate"
                                   style={{
                                       lineHeight: '1.3em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1,
                                   }}
                                >{thisBook?.title}</p>
                                <p className="fst-italic mb-1 text-muted small"
                                   style={{
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 2, // Ограничение до 2 строк
                                   }}
                                >{thisBook?.subtitle || 'No subtitle'}</p>
                                <p className="mb-1"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}
                                ><FaBookOpen className="me-1" />{thisBook?.author}</p>
                                <p className="mb-1"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}
                                ><FaGlobe className="me-1" />{thisBook?.language}, {thisBook?.total_words} words</p>
                                <p className="mb-1"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}
                                ><FaCalendar className="me-1" />{`${month}-${day}-${year}`}</p>
                                <p className="mb-1"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}
                                ><FaInfoCircle className="me-1" />{thisBook?.status}, Reviews: {bookRatingInfo?.totalReviews || 'No'}</p>
                                <p className="mb-0"
                                   style={{
                                       lineHeight: '0.9em',
                                       display: '-webkit-box',
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden',
                                       WebkitLineClamp: 1, // Ограничение до 2 строк
                                   }}
                                >
                                    <FaStarHalfAlt className="me-1" />
                                    {[...Array(5)].map((_, index) => {
                                        const rating = bookRatingInfo?.successRating || 0;
                                        const full = index < Math.floor(rating);
                                        const half = index === Math.floor(rating) && rating % 1 >= 0.3 && rating % 1 <= 0.7;
                                        const cls = full ? "bi-star-fill" : half ? "bi-star-half" : "bi-star";
                                        const color = full || half ? "gold" : "lightgray";
                                        return <i key={index} className={`bi ${cls}`} style={{ color, fontSize: '13px', marginRight: '2px' }} />;
                                    })}
                                    &nbsp;<strong>({bookRatingInfo?.successRating || 'No'})</strong>
                                </p>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            )}
        </>
    );

};

export default BookItems;
